<ui-dialog-actions>
    <ui-button
        [disabled]="pending$ | async"
        [loading]="pending$ | async"
        [square]="true"
        [label]="'global.actions.confirm' | translate"
        (handlerClick)="handlerClickConfirm()" />
</ui-dialog-actions>
